export default __webpack_public_path__ + "static/media/my-web-platforms-blue.e9a0b3c3.svg";